<template>

  <b-modal hide-footer title="Central Cliente" @hide="onHidden()" id="modal-support">

    <div class="d-block text-center align-items-center justify-content-center">

      <a href="https://www.onlaine.com.br" target="_blank"><img src="https://static.onlaine.com.br/images/logo.png"
                                                                style="width: 200px; margin-right: -70px"/></a>

      <div>

        <h4>Onlaine Tecnologia</h4>
        <p>Atendimento seg. à sex. das 09h00 às 18h00<br/></p>


        <b-row>


          <b-col cols="12" class="justify-content-center align-content-center">
            <div class="mb-3 color-onlaine">
              <a href="https://api.whatsapp.com/send?phone=5511950025976&text=Olá gostaria de suporte técnico."
                 target="_blank">
                <b-icon-whatsapp/>
                Conversar com Atendimento via WhatsApp</a>
            </div>

          </b-col>


          <!--          <b-col cols="4">


                      <div class="mb-3 color-onlaine">

                        <a href="https://error.onlaine.com/" target="_blank">
                          <b-icon-exclamation-triangle/>
                          Abrir Chamado</a><br/>

                      </div>

                    </b-col>-->

          <!--          <b-col cols="4">

                      <div class="mb-3 color-onlaine">

                        <a href="https://suggestion.onlaine.com/" target="_blank">
                          <b-icon-lightbulb/>
                          Sugerir melhoria</a><br/>

                      </div>

                    </b-col>-->

        </b-row>


        <a :href="helpDocUrl" v-if="helpDocUrl !==''" @click="closeDialog()" target="_blank"
           class="btn btn-shadow mb-3 mt-2 mb-2 mr-2 btn-outline-primary btn-md">
          <b-icon-book/>
          Manuais Específicos</a>

        <a href="https://getscreen.me/go/" @click="closeDialog()" target="_blank"
           class="btn btn-shadow mb-3 mt-2 btn-outline-primary btn-md">
          <b-icon-box-arrow-up-right/>

          Link para Acesso Remoto</a>

      </div>


    </div>
  </b-modal>

</template>
<script>
import ui from "@/assets/scripts/ui";

export default {
  name: 't-dialog-support',
  data() {
    return {
      status: "",
      helpDocUrl: "",
    }
  },

  methods: {

    closeDialog() {
      this.onHidden()
      this.$bvModal.hide('modal-support')
    },

    onHidden() {
      this.$bvModal.hide('modal-support')
      this.$emit("hide")
    }

  },
  async mounted() {

    this.helpDocUrl = ui.getAccountHelpDocURL()

  },
}
</script>
